var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAlarm = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 12 14"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 6,
  cy: 7.285,
  r: 5.143,
  stroke: "currentColor"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  d: "M6 5v2.095c0 .119.06.23.159.297l1.555 1.037M8.858 1l2.285 1.714M6 1v1.143M8.858 11.857 9.429 13M3.143 11.857 2.57 13M3.143 1 .857 2.714"
})));
export { SvgAlarm as ReactComponent };
export default __webpack_public_path__ + "static/media/alarm.d73e5a0890381669d3f020b4495a3ba7.svg";